import { jsonLdScriptProps } from 'react-schemaorg'
import { Event, Organization, EventStatusType, VirtualLocation } from 'schema-dts'
import { DetailedHTMLProps, ScriptHTMLAttributes } from 'react'
import addSeconds from 'date-fns/addSeconds'
import formatISODuration from 'date-fns/formatISODuration'
import intervalToDuration from 'date-fns/intervalToDuration'
import parseISO from 'date-fns/parseISO'
import { WebcastResponse } from '../fetchWebcast'
import { ChannelResponse } from '../fetchChannel'

const getStructuredData = ({
    channelName,
    channelDescription,
    channelUrl
  }: ChannelResponse, {
    title, description, start, end,
    status, duration,
    previewImg, presenter, isGigCancelled, url, rating, ratingCount
  }: WebcastResponse,
  canonicalUrl: string
): DetailedHTMLProps<ScriptHTMLAttributes<HTMLScriptElement>, HTMLScriptElement> => {

  if (!start) return

  const now = new Date(0)

  const _end = end !== '' ? end : addSeconds(parseISO(start), duration ?? 0).toISOString()
  const interval = formatISODuration(
      intervalToDuration({
      start: now,
      end: addSeconds(now, duration ?? 0)
    })
  )

  const durationFormatted =`P${interval.substr(interval.indexOf('T'))}`

  const organizer: Organization = {
      '@type': 'Organization',
      name: channelName,
      description: channelDescription,
      url: channelUrl
  }

  const location: VirtualLocation = {
    '@type': 'VirtualLocation',
    name: 'BrightTALK',
    url: url,
    description: description,
    image: previewImg
  }

  const getEventStatus = (): EventStatusType => {

    if (isGigCancelled) return 'EventCancelled'

    switch (status) {

      case 'upcoming':
        return 'EventScheduled'
      default:
        return 'EventScheduled'
  
    }

  }

  const eventStatus: EventStatusType = getEventStatus()

  const bestRating = 5
  const worstRating = 1
  const hasValidRating = rating && rating >= worstRating && rating <= bestRating

  const baseEvent: Event = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: title,
    description,
    about: description,
    startDate: start,
    endDate: _end,
    url: canonicalUrl,
    duration: durationFormatted,
    location,
    image: previewImg,
    performer: presenter,
    organizer,
    eventAttendanceMode: 'OnlineEventAttendanceMode',
    eventStatus
  }

  if (hasValidRating) {
    baseEvent.aggregateRating = {
      '@type': 'AggregateRating',
      bestRating: bestRating.toString(),
      worstRating: worstRating.toString(),
      ratingValue: rating.toString(),
      ratingCount: ratingCount?.toString()
    }
  }

  return jsonLdScriptProps<Event>(baseEvent)

}

export default getStructuredData
